import PropTypes from 'prop-types';

//eslint-disable-next-line no-unused-vars
const Header = ({ dataKey }) => null;

Header.propTypes = {
    dataKey: PropTypes.string.isRequired,
};

export default Header;
